import { ThemeProvider } from '@mui/material'
import { LicenseInfo } from '@mui/x-license'
import ReplenishmentPlan from '@/ui/screens/ReplenishmentPlan/ReplenishmentPlan'
import { PlanIdsContext } from '@/core/hooks/PlanIdsContext'
import { Analytics } from '@/core/analytics'
import { theme } from '@/core/theme/theme'
import '@/core/l10n/config'

if (import.meta.env.VITE_MUI_LICENSE_KEY) {
  LicenseInfo.setLicenseKey(import.meta.env.VITE_MUI_LICENSE_KEY)
}

// Was in the deleted foresight main.tsx; Mixpanel must be initialized before any
// track()/identify() call, else plan analytics are silently dropped in production.
if (import.meta.env.VITE_ANALYTICS_PROJECT_TOKEN) {
  Analytics.init(import.meta.env.VITE_ANALYTICS_PROJECT_TOKEN)
}

interface IProps {
  accountId: number
  branchId: number
}

// Renders the foresight plan inline in the legacy app. Foresight hooks read account/branch
// ids via useAccountBranchIdsParams(), which prefers this context when the host route carries
// no ids in the URL. Store + router come from the host app; theme/i18n are scoped here so
// they don't restyle legacy screens.
const PlanEmbed = ({ accountId, branchId }: IProps) => (
  <PlanIdsContext.Provider value={{ accountId, branchId }}>
    <ThemeProvider theme={theme}>
      <div className="replenishment_embed">
        <ReplenishmentPlan />
      </div>
    </ThemeProvider>
  </PlanIdsContext.Provider>
)

export default PlanEmbed
